<template>
  <div class="max-resolution">
    <div class="banner page-head flex-box" style="min-height: 100px">
      <div class="w-100">
        <div class="banner-caption text-center">
          <h2 class="features-header-text ml-0 mt-5 text-center">Pricing</h2>
          <h5 style="color: #676767">
            Free for the open-data community <br />
            Pay-as-you-go for your business
          </h5>
        </div>
      </div>
    </div>
    <div class="row col-md-12 mt-5 container">
      <div class="col-md-4 text-center box">
        <div class="analytics-header m-5">FREE</div>
        <ul class="meet-list m-3">
          <li>15 Automated Flows</li>
          <li>100 Conversational Engagements</li>
          <li>Unlimited Upsell/Cross-sell Configurations</li>
          <li>Google Analytics Integration</li>
          <li>Unlimited Users</li>
        </ul>
        <div style="display: flex; justify-content: center; height: 60px">
          <div
            style="
              width: 80px;
              height: 0px;
              display: flex;
              padding-top: 13px;
              color: #3a3a3a;
              opacity: 1;
              font-size: 1.8rem;
              font-family: Rubik;
              line-height: 47px;
              font-weight: bold;
            "
          >
            FREE
          </div>
        </div>

        <!-- <h2 class="features-header-text pt-2 mt-4 ml-4 mr-4 mb-0 text-center">
          Free
        </h2> -->
        <!-- <h5 style="color: #676767">Non Commercial</h5> -->
        <br />
        <button class="white-btn-analytics box:hover" @click="route('register')">
          START FOR FREE
        </button>
      </div>
      <div class="col-md-4 text-center box">
        <div class="analytics-header m-5">STARTER</div>
        <ul class="meet-list m-3">
          <li>Unlimited Automated Flows</li>
          <li>5000 Conversational Engagements</li>
          <li>2500 Marketing Emails</li>
          <li>SMS Marketing ($0.015 / msg)</li>
          <!-- <li style="opacity:0"> Lorem ipsum dolor sit,  </li> -->
        </ul>
        <div style="display: flex; justify-content: center; height: 60px">
          <div
            style="
              width: 158px;
              height: 0px;
              display: flex;
              
              
              padding-top: 13px;
              color: #3a3a3a;
              opacity: 1;
              font-size: 1.8rem;
              font-family: Rubik;
              line-height: 47px;
              font-weight: bold;
            "
          >
            $29/month
          </div>
          <!-- <div
            style="
              width: 100px;
              display: flex;
              justify-content: center;
              text-align: left;
              font: normal 14px/82px Rubik;
              letter-spacing: 0px;
              color: #3a3a3a;
            "
          >
            /column/month
          </div> -->
        </div>

        <!-- <h2 class="features-header-text mt-4 ml-4 mr-4 mb-0 text-center">
          $4 <span class="newfont">/column/month</span>
        </h2> -->
        <!-- <h5 style="color: #676767">Starting from</h5> -->
        <br />
        <button class="white-btn-analytics" @click="route('register')">
          START FOR FREE
        </button>
      </div>
      <div class="col-md-4 text-center box">
        <div class="analytics-header m-5">PREMIUM</div>
        <ul class="meet-list m-3">
          <li>All STARTER features</li>
          <li>Visual Designer</li>
          <li>Unlimited Conversational Engagements</li>
          <li>25000 Marketing Emails</li>
          <li>Additional Chat and Email Support</li>
        </ul>
        <div style="display: flex; justify-content: center; height: 60px">
          <div
            style="
              width: 158px;
              height: 0px;
              display: flex;
              
              padding-top: 13px;
              color: #3a3a3a;
              opacity: 1;
              font-size: 1.8rem;
              font-family: Rubik;
              line-height: 47px;
              font-weight: bold;
            "
          >
            $99/month
          </div>
          <!-- <div
            style="
              width: 100px;
              display: flex;
              justify-content: center;
              text-align: left;
              font: normal 14px/82px Rubik;
              letter-spacing: 0px;
              color: #3a3a3a;
            "
          >
            /column/month
          </div> -->
        </div>
        <!-- <h5 style="color: #676767">Starting from</h5> -->
        <br />
        <button class="white-btn-analytics" @click="route('register')">
          START FOR FREE
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  methods: {
    route(name){
      if(this.$route.path != `/${name}`){
        this.$router.push(`/${name}`)
        $('html, body').animate({ scrollTop: 0 }, 'fast');

      } else{
          $('html, body').animate({ scrollTop: 0 }, 'fast');
      }
    },
  },
}
</script>

<style lang="scss" scoped>
h5 {
  font-family: "Rubik";
  font-size: 1.375rem;
  line-height: 1.875rem;
  font-weight: normal;
}

.features-header-text {
  text-align: left;
  letter-spacing: 0px;
  color: #3a3a3a;
  opacity: 1;
  text-align: left;
  font: bold 2.5rem/2.8125rem Rubik;
  font-family: Rubik;
  line-height: 47px;
  font-weight: bold;
  margin-left: 10%;
}
.newfont {
  text-align: left;
  font: normal 14px/82px Rubik;
  letter-spacing: 0px;
  color: #3a3a3a;
}
.max-resolution {
  max-width: 1440px;
  margin: auto !important;
}

.analytics-header {
  // width: 220px;
  font: normal normal bold 20px/68px Rubik;
  letter-spacing: 0px;
  color: #283677;
  text-transform: uppercase;
  opacity: 1;
  text-align: center;
}

.white-btn-analytics {
  border-radius: 26px;
  opacity: 1;
  height: 52px;
  width: 200px;
}

// .white-btn-analytics:hover {
//   background: none;
//   color: #FFFFFF;
//   background-color: #273679;
// }
.container {
  width: 85%;
  padding: 10px;
  background: #ffffff;
  margin: 100px auto;
  display: flex;
  justify-content: center;
}

.box {
  /* width: 15px; */
  height: auto;
  background: #ffffff;
  box-shadow: 1px 0px 6px #00000029;
  opacity: 1;
  /* float: left; */
  margin: 0px;
  transition: 1s;
  padding-bottom: 1.5rem;
}

.box:hover {
  .white-btn-analytics {
    background: none;
    color: #FFFFFF;
    background-color: #273679;
  }
  transform: scale(1.1);
  border: 3px solid #283677;
  z-index: 2;
}

.meet-list {
  font: normal 1rem/2.5rem Rubik;
  letter-spacing: 0px;
  color: #787878;
  opacity: 1;
  margin-left: auto;
  /* text-align: center; */
  margin-block-start: 0;
  padding-inline-start: 1.5rem;
  text-align: left;
  justify-content: center;
  padding-left: 50px;
  min-height: 18rem;
}

.meet-list li {
  text-align: left;
  list-style-image: url("../assets/img/Tick_Mark_Green.svg");
}

@media(max-width: 900px) {
  .box {
    padding-bottom: 1.5rem;
  }
  // .analytics-header {
  //   width: auto;
  // }
  // .meet-list {
  //   padding-left: 0;
  // }

}

</style>